import React from "react";
import { BiLoaderAlt } from "react-icons/bi";

const Loading2 = () => {
  return (
    <div className='h-screen bg-white dark:bg-black w-full flex items-center justify-center'>
      <BiLoaderAlt className='text-6xl text-primary animate-spin' />
    </div>
  );
};

export default Loading2;
